import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRightIcon } from "lucide-react";
const ease = [0.23, 1, 0.32, 1] as const;
const HERO_IMAGE = "https://cdn.magicpatterns.com/patterns/generated-images/929edc53-852c-45b4-8644-e3f59aad3a85.jpg";
export function Hero() {
  return <section className="relative flex min-h-[640px] w-full items-end overflow-hidden bg-ink" style={{
    height: "100svh"
  }} data-id="element-124" data-mp="4n1ov1j4iux9">
      <img src={HERO_IMAGE} alt="Van aménagé garé sur une colline verdoyante au coucher du soleil" className="absolute inset-0 h-full w-full object-cover" data-id="element-125" data-mp="127eeddqu7pdg" />
      <div className="absolute inset-0 bg-ink/45" aria-hidden="true" data-id="element-126" data-mp="s9ggdyj6ee7n" />

      <div className="relative mx-auto w-full max-w-site px-5 pb-16 md:px-8 md:pb-24" data-id="element-127" data-mp="nb6llp1d5fmk">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease
      }} className="max-w-3xl" data-id="element-128" data-mp="3d1scj2wkntvr">
          <h1 className="font-display text-6xl font-medium leading-[0.95] tracking-tight text-white md:text-8xl" data-id="element-129" data-mp="3j7zhzqi0g6kd">
            Transformer
            <br data-id="element-130" data-mp="3o73p8bldju82" />
            <span className="italic" data-id="element-131" data-mp="3o5j2h85axfkr">votre van.</span>
          </h1>
          <p className="mt-6 max-w-xl text-lg leading-relaxed text-white/90 md:text-xl" data-id="element-132" data-mp="399jo5frlmj76">
            Solutions d'aménagement de vans pour des aventures inoubliables — conçues et réalisées dans notre atelier du Pays Basque.
          </p>
          <div className="mt-10 flex flex-col gap-3 sm:flex-row" data-id="element-133" data-mp="30g6m9obk478y">
            <a href="#amenagements" className="group inline-flex items-center justify-center gap-2 rounded-full bg-clay px-7 py-4 text-base font-semibold text-white transition-colors duration-150 hover:bg-clay-dark" data-id="element-134" data-mp="35aatm8oqihak">
              Découvrir nos aménagements
              <ArrowRightIcon className="h-5 w-5 transition-transform duration-200 group-hover:translate-x-1" aria-hidden="true" data-id="element-135" data-mp="2hjoytj3qqtii" />
            </a>
            <Link to="/contact" className="inline-flex items-center justify-center rounded-full border border-white/60 px-7 py-4 text-base font-semibold text-white transition-colors duration-150 hover:bg-white hover:text-ink" data-id="element-136" data-mp="s21k8hdb6o2m">
              Parler de mon projet
            </Link>
          </div>
        </motion.div>
      </div>
    </section>;
}